exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!vue-select/dist/vue-select.css"), "");

// module
exports.push([module.id, "\n/*@import \"~air-datepicker/dist/css/datepicker.min.css\";*/\n.custom-v-select .vs__dropdown-option--disabled[data-v-64a5d812] {\n  color: #000;\n  font-weight: bold;\n  padding: 3px 7px 4px;\n  cursor: not-allowed;\n}\n.custom-v-select ul[role='listbox'][data-v-64a5d812] {\n  border: 1px solid #5897fb;\n  border-top: none;\n}\n.video-wrapper[data-v-64a5d812] {\n  position: relative;\n  padding-bottom: 56.25%; /* 16:9 */\n  padding-top: 25px;\n  height: 0;\n}\n.video-wrapper iframe[data-v-64a5d812] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-64a5d812","scoped":true,"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/professional/ProfessionalRegister.vue
// module id = 2000
// module chunks = 0